/***/
const styles = () => ({ helperText: { marginTop: 7 }, chipsWrapper: { display: 'flex', gap: 10 } })
export default styles
